import { useEffect, useRef, useState } from 'react';
import { useIoContext, useStore } from '~/contexts';
export function useNativeSplashOverlay(param) {
    let { fadeOutMs, hideSafetyMs } = param;
    const { native } = useIoContext();
    const authFlowDone = useStore((state)=>state.authFlowDone);
    const [phase, setPhase] = useState('looping');
    const [animationData, setAnimationData] = useState(null);
    const hasHidden = useRef(false);
    const hideNativeSplash = ()=>{
        if (hasHidden.current) return;
        hasHidden.current = true;
        void native.hideSplashScreen();
    };
    useEffect(()=>{
        let active = true;
        void import('../anchor-splash.json').then((module)=>{
            if (active) setAnimationData(module.default);
        });
        return ()=>{
            active = false;
        };
    }, []);
    useEffect(()=>{
        const timer = setTimeout(hideNativeSplash, hideSafetyMs);
        return ()=>clearTimeout(timer);
    }, [
        hideSafetyMs
    ]);
    useEffect(()=>{
        if (!authFlowDone) return;
        hideNativeSplash();
        setPhase('fading');
        const timer = setTimeout(()=>setPhase('done'), fadeOutMs);
        return ()=>clearTimeout(timer);
    }, [
        authFlowDone,
        fadeOutMs
    ]);
    const onFirstFramePainted = ()=>hideNativeSplash();
    return {
        phase,
        animationData,
        onFirstFramePainted
    };
}
